<template>
  <div>
    <ModuleLink
      v-if="$store.state.AdminMode"
      :module-properties="menuItem"
      :show-only-icon="true"
    />
    <h3
      v-if="menuItem.SefUrl || menuItem.CustomUrl"
      class="nav-dropdown-group-title relative z-1"
    >
      <MenuItem
        :as="VirtualLink"
        v-slot="{ active }"
        :close-menu-on-click="true"
        :href="menuItem.CustomUrl ? menuItem.CustomUrl : menuItem.SefUrl"
        :target="menuItem.Target"
      >
        <span :class="active ? 'text-htz-red' : 'text-htz-darkgrey'">
          {{ menuItem.Name }}
        </span>
      </MenuItem>
    </h3>
    <h3
      v-else
      class="relative z-1"
    >
      {{ menuItem.Name }}
    </h3>
    <ul
      :class="menuItem.MenuItemOption == 'LEFT_BORDER' ? 'nav-list-blockquote' : 'nav-list-content'"
    >
      <template
        v-for="(menuItemChild, index) in menuItem.Children.filter((obj) => obj.MenuItemOption == '' || obj.MenuItemOption == null)"
        :key="menuItemChild.EntityID"
      >
        <ModuleLink
          v-if="$store.state.AdminMode"
          :module-properties="menuItemChild"
          :show-only-icon="true"
        />
        <li
          v-if="(menuItemChild.SefUrl || menuItemChild.CustomUrl) && index < numbOfLinksToShow(menuItem.MenuItemOption)"
        >
          <MenuItem
            :as="VirtualLink"
            :close-menu-on-click="true"
            :target="menuItemChild.Target"
            :href="menuItemChild.CustomUrl ? menuItemChild.CustomUrl : menuItemChild.SefUrl"
            v-slot="{ active }">

            <span :class="active ? 'text-htz-red' : 'text-htz-darkgrey'">{{ menuItemChild.Name }}</span>

          </MenuItem>
        </li>
      </template>
    </ul>
    <template
      v-if="(menuItem.SefUrl || menuItem.CustomUrl) && menuItem.Children.filter((obj) => (obj.SefUrl || obj.CustomUrl) && (obj.MenuItemOption == '' || obj.MenuItemOption == null)).length > numbOfLinksToShow(menuItem.MenuItemOption)">
      <MenuItem
        :as="VirtualLink"
        v-slot="{ active }"
        :close-menu-on-click="true"
        :href="menuItem.CustomUrl ? menuItem.CustomUrl : menuItem.SefUrl"
        :target="menuItem.Target"
        class-list="btn-small text-12 lg:text-15 pl-0 mt-1"
      >
        <span :class="active ? 'text-htz-red' : 'text-htz-darkgrey'">
          {{ $t("loc_view_more") }}
        </span>
      </MenuItem>
    </template>
    <br v-if="menuItem.Children.filter((obj) => (obj.SefUrl || obj.CustomUrl) && (obj.MenuItemOption == '' || obj.MenuItemOption == null)).length > numbOfLinksToShow(menuItem.MenuItemOption)">
    <div
      v-if="(menuItem.Children.filter((obj) => (obj.SefUrl || obj.CustomUrl) && obj.MenuItemOption == 'HIGHLIGHT')).length > 0"
      class="w-full lg:w-auto inline-flex flex-col items-start space-y-2 pt-3 pb-3 lg:pb-0"
    >
      <template
        v-for="menuItemChild in menuItem.Children.filter((obj) => (obj.SefUrl || obj.CustomUrl) && obj.MenuItemOption == 'HIGHLIGHT')"
        :key="menuItemChild.EntityID"
      >
        <ModuleLink
          v-if="$store.state.AdminMode"
          :module-properties="menuItemChild"
          :show-only-icon="true"
        />
        <MenuItem
          :as="VirtualLink"
          v-slot="{ active }"
          :href="menuItemChild.CustomUrl ? menuItemChild.CustomUrl : (menuItemChild.SefUrl ? menuItemChild.SefUrl : '#')"
          :close-menu-on-click="true"
          :target="menuItemChild.Target"
          class-list="link-grey"

        >
          <span class="link-underline">
            <span :class="active ? 'text-htz-red' : 'text-htz-darkgrey'">{{ menuItemChild.Name }}</span>
          </span>
        </MenuItem>

      </template>
    </div>
  </div>
</template>

<script>
import { menuMixin } from "@/mixins";
import {MenuItem} from "@headlessui/vue";
import VirtualLink from "@/components/includes/router/VirtualLink";

export default {
  mixins: [menuMixin],
  components: {
    MenuItem,
  },
  data() {
    return {
      VirtualLink,
    }
  },
  props: {
    menuItem: {
      type: Object,
      default: () => ({}),
    }
  },
  methods: {
    numbOfLinksToShow(menuItemOption){
      if(menuItemOption !== 'LEFT_BORDER'){
        return this.getNumbOfItemsToShow();
      }
      else {
        return 15;
      }
    }

  },
};
</script>
